//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { Alert } from '@components/atoms/alert/Alert';
import { getIsInstagramEngagementRateUpdateEnabled } from '@instagram-account/hooks/getIsInstagramEngagementRateUpdateEnabled';
import makeAngularReactController from '@react-bridge/angular-react-widget';

// TODO: PD-285232 - Remove IG engagement rate update banner
export const InstagramEngagementRateUpdateBanner = () => {
  const isInstagramEngagementRateUpdateEnabled = useSelector(
    getIsInstagramEngagementRateUpdateEnabled,
  );

  const progressText = isInstagramEngagementRateUpdateEnabled
    ? 'now'
    : 'are in the process of being updated to';

  return (
    <Alert type='warning'>
      Instagram Feed and Reel Engagement Rate {progressText} include shares and
      saves.
    </Alert>
  );
};

angular.module('curalate').component('instagramEngagementRateUpdateBanner', {
  controller: makeAngularReactController(
    <InstagramEngagementRateUpdateBanner />,
  ),
});
